import { Stack } from "@mui/material";

import { type ShiftBlockWithMappedDetails } from "./api/useFetchPaginatedShiftBlocks";
import { ShiftBlockShiftCard } from "./ShiftBlockShiftCard";

interface ShiftBlockShiftDetailsProps {
  shiftBlockWithDetails: ShiftBlockWithMappedDetails;
  agentTimezone: string;
  mandatoryBreakDurationInMinutes: number;
}

export function ShiftBlockShiftDetails(props: ShiftBlockShiftDetailsProps) {
  const { shiftBlockWithDetails, agentTimezone, mandatoryBreakDurationInMinutes } = props;

  return (
    <Stack spacing={3}>
      {shiftBlockWithDetails.shifts.map((shift) => (
        <ShiftBlockShiftCard
          key={shift.id}
          agentTimezone={agentTimezone}
          mandatoryBreakDurationInMinutes={mandatoryBreakDurationInMinutes}
          shift={shift}
        />
      ))}
    </Stack>
  );
}
